import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "./ids.js";
/** Tenant scope for isolation checks (D-034 / tenant-isolation-pack). */
export const TenantScopeSchema = z.object({
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
});
/** Artifacts served to clients must be clientSafe:true (Constitution §8.2). */
export const ClientSafeFlagSchema = z.boolean();
//# sourceMappingURL=tenant.js.map